import React from "react";

import {
  FaPhoneVolume,
  FaInstagram,
  FaFacebook,
  FaLinkedin,
} from "react-icons/fa6";

import { IoMail } from "react-icons/io5";
import { HiClock } from "react-icons/hi2";
import { AiFillYoutube } from "react-icons/ai";

const Headerinfo = () => {

  const handleClick = (link) => {
    window.open(link, "_blank");
  };

  return (
    <section className="hidden lg:block bg-[#F8FCFB] border-b border-[#E7F3F0]">
      
      <div className="max-w-[1450px] mx-auto px-[5%] h-[58px] flex items-center justify-between">

        {/* LEFT SIDE */}
        <div className="flex items-center gap-7">
          {/* PHONE */}
          <div className="flex items-center gap-3 group">
            <div className="w-[36px] h-[36px] rounded-full bg-primary/10 flex items-center justify-center transition-all duration-300 group-hover:bg-primary">
              <FaPhoneVolume className="text-primary text-[15px] group-hover:text-white transition-all duration-300" />
            </div>

            <div>
              <p className="text-[11px] uppercase tracking-[1px] text-gray-400 font-medium">
                Call Us
              </p>

              <h1 className="text-[14px] font-[500] text-[#1E293B] font-poppins">
                +91 72009 95976
              </h1>
            </div>
          </div>

          {/* EMAIL */}
          <div className="flex items-center gap-3 group">
            <div className="w-[36px] h-[36px] rounded-full bg-primary/10 flex items-center justify-center transition-all duration-300 group-hover:bg-primary">
              <IoMail className="text-primary text-[16px] group-hover:text-white transition-all duration-300" />
            </div>

            <div>
              <p className="text-[11px] uppercase tracking-[1px] text-gray-400 font-medium">
                Email
              </p>

              <h1 className="text-[14px] font-[500] text-[#1E293B] font-poppins">
                info@livmohealth.com
              </h1>
            </div>
          </div>

          {/* TIME */}
          <div className="flex items-center gap-3 group">
            <div className="w-[36px] h-[36px] rounded-full bg-primary/10 flex items-center justify-center transition-all duration-300 group-hover:bg-primary">
              <HiClock className="text-primary text-[17px] group-hover:text-white transition-all duration-300" />
            </div>

            <div>
              <p className="text-[11px] uppercase tracking-[1px] text-gray-400 font-medium">
                Working Hours
              </p>

              <h1 className="text-[14px] font-[500] text-[#1E293B] font-poppins">
                Mon - Sat : 9AM - 6PM
              </h1>
            </div>
          </div>

        </div>

        {/* RIGHT SIDE SOCIALS */}
        <div className="flex items-center gap-3">

          <button
            onClick={() =>
              handleClick("https://www.youtube.com/@LivmoHealth")
            }
            className="w-[38px] h-[38px] rounded-full bg-white border border-[#E2E8F0] flex items-center justify-center text-primary transition-all duration-300 hover:bg-primary hover:text-white hover:shadow-lg hover:shadow-primary/20"
          >
            <AiFillYoutube className="text-[18px]" />
          </button>

          <button
            onClick={() =>
              handleClick("https://www.instagram.com/livmohealth/")
            }
            className="w-[38px] h-[38px] rounded-full bg-white border border-[#E2E8F0] flex items-center justify-center text-primary transition-all duration-300 hover:bg-primary hover:text-white hover:shadow-lg hover:shadow-primary/20"
          >
            <FaInstagram className="text-[16px]" />
          </button>

          <button
            onClick={() =>
              handleClick("https://www.linkedin.com/company/livmo-health/")
            }
            className="w-[38px] h-[38px] rounded-full bg-white border border-[#E2E8F0] flex items-center justify-center text-primary transition-all duration-300 hover:bg-primary hover:text-white hover:shadow-lg hover:shadow-primary/20"
          >
            <FaLinkedin className="text-[16px]" />
          </button>

          <button
            onClick={() =>
              handleClick(
                "https://www.facebook.com/profile.php?id=61577010659413"
              )
            }
            className="w-[38px] h-[38px] rounded-full bg-white border border-[#E2E8F0] flex items-center justify-center text-primary transition-all duration-300 hover:bg-primary hover:text-white hover:shadow-lg hover:shadow-primary/20"
          >
            <FaFacebook className="text-[16px]" />
          </button>

        </div>
      </div>
    </section>
  );
};

export default Headerinfo;